import { cloneElement } from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import { 
  chevronDoubleUpIcon, 
  chevronUpIcon, 
  equalIcon, 
  chevronDownIcon 
} from '@progress/kendo-svg-icons';

//Metric Operators
interface Operator {
    text: string;
    value: string;
  }

export const metricOperators: Operator[] = [
    { text: "=", value: "eq" },
    { text: "≠", value: "neq" },
    { text: ">", value: "gt" },
    { text: "<", value: "lt" },
    { text: "≥", value: "gte" },
    { text: "≤", value: "lte" },
  ];

export const dataField = [
    { fieldName: "EstimatedVolume", fieldId: 1, typeId: 1, operatorId: 1 },
    { fieldName: "ProjectedDepletionDate", fieldId: 2, typeId: 1, operatorId: 1 },
    { fieldName: "EstimatedVolumeAsPercentage", fieldId: 3, typeId: 1, operatorId: 1 },
    { fieldName: "NumberOfConsecutiveFailures", fieldId: 4, typeId: 2, operatorId: 2 },
  ];

 export const dataOperator = [
    { text: "=", value: "eq", operatorId: 1},
    { text: "≠", value: "neq", operatorId: 1},
    { text: ">", value: "gt", operatorId: 1},
    { text: "<", value: "lt", operatorId: 1},
    { text: "≥", value: "gte", operatorId: 1},
    { text: "≤", value: "lte", operatorId: 1},
    { text: "≥", value: "gte", operatorId: 2 },
  ]


  //Criticality
  export const valueRenderCriticality = (element: any, value: any) => {
    if (!value) {
      return element;
    }
    
    // Handle both object (from dropdown) and string (from initial value) formats
    const criticalityValue = typeof value === 'object' && value !== null ? value.value : value;
    
    if (!criticalityValue) {
      return element;
    }
    
    const colour = criticalityValue === "Critical" ? "#780000" : 
                  criticalityValue === "High" ? "#dc0000" : 
                  criticalityValue === "Medium" ? "#fd8c00" : 
                  "#fdc500";
                  
    const icon = criticalityValue === "Critical" ? chevronDoubleUpIcon : 
                criticalityValue === "High" ? chevronUpIcon : 
                criticalityValue === "Medium" ? equalIcon : 
                chevronDownIcon;

    const children = [
      <span
        key={1}
        style={{ 
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '26px',
          height: '26px',
          color: colour 
        }}
      >
        <SvgIcon icon={icon} />
      </span>,
      <span key={2}>&nbsp; {element.props.children}</span>,
    ];

    return cloneElement(element, { ...element.props }, children);
  };